import { jsx as _jsx } from "react/jsx-runtime";
import { InputAdornment } from '@ori-ui/mui';
import { Icon } from './Icon';
export var AdornmentIcon = function(props) {
    var fieldState = props.fieldState, _props_text = props.text, text = _props_text === void 0 ? '' : _props_text;
    var message = fieldState.error ? text : undefined;
    return /*#__PURE__*/ _jsx(InputAdornment, {
        position: "end",
        children: /*#__PURE__*/ _jsx(Icon, {
            text: message
        })
    });
};
